
// see https://github.com/travcorp/itropics/search?utf8=%E2%9C%93&q=25029
export const prepaidGratuitiesProductCategoryId = 25029
export const hotelPickupsProductCategoryIds = [66894]
export const ontarioTravelProtectionTax = 0.08
  export const regionalDomains = {
    UKLS: 'uk',
    BEUS: 'uk',
    BAUS: 'uk',
    USAS: 'us',
    SYDS: 'au',
    CANS: 'ca',
    JBGS: 'za',
    SINS: 'asia',
    AKLS: 'nz',
    EUOS: 'eu',
  }
export const thirdPartyReferenceMaxLength = 11
export const flightTypes = ['IOF', 'NFIT', 'AIR', 'FAIR', 'AIRTTC', 'FIT']
export const accomodationTypes = ['PRE', 'POST', 'HTL']
export const promisedFlightProductId = 418100
export const tourTypes = {
  DAY_TOUR: {
    name: 'dayTour',
    operatingCompanies: [
      {
        code: 'AATMSO',
        productClassificationIds: [
          24997, // "Day Tours"
          25994, // "3rd Party Day Tour"
        ],
      },
    ],
  },
  SHORT_BREAK: {
    name: 'shortBreak',
    operatingCompanies: [
      {
        code: 'AATMSO',
        productClassificationIds: [
          24209, // "Stopovers"
          24901, // "Short Breaks Other"
          25005, // "Short Breaks"
          30893, // "Other Escorted"
          35495, // "Mini Stay"
        ],
      },
    ],
  },
  GUIDED_HOLIDAY: {
    // leave this stub type definition here as it is the default tour type and the name is referenced elsewhere.
    name: 'guidedHoliday',
  },
}
export const partySize = {
  min: 1,
  max: 8,
}
export const airfareMaxChildAge = 11
export const goldSealMiscServiceId = 20275
export const changeTriggeringProfileEnum = {
  travelAgent: 'TA',
  customer: 'CU',
  batch: 'BA',
}
export const changeTriggeringSystemEnum = {
  travelAgentPlatform: 'TP',
  bookingEngine: 'BE',
  myTravelPortal: 'MT',
}

